var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 22.2293,
    d: "M505.875 50.213c-212.115 5.725-252.023 162.276-240.696 280.057 1.761 18.288 10.113 34.966 23.356 49.765 1.241-11.61 2.942-23.028 5.335-34.273-0.893 9.979-1.27 20.194-1.27 30.464 0 94.826 38.898 178.597 98.010 228.003-3.939 23.182-12.795 42.969-25.896 67.030l-221.4 47.483c-107.325 24.829-115.449 177.649-108.165 255.175 956.121-2.713-1.848 1.594 955.684-2.033-3.275-84.746-15.252-235.386-124.41-258.725l-209.725-39.866c-0.018-0.673 0.047-1.357 0-2.033l-12.951-71.343c56.367-49.865 93.18-131.493 93.18-223.689 0-0.932 0.009-1.867 0-2.797 0.908 4.648 1.819 9.24 2.539 13.199 12.023-16.207 9.205-43.959 12.443-65.761 16.857-113.452-47.028-267.314-224.7-270.655-7.204-0.139-14.484-0.186-21.331 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.91c0e7a685f4cdf65831b78754d7500e.svg";
export { ForwardRef as ReactComponent };